import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { headerFontFamily } from "styles/theme/mui";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    height: "42px",
  },
  actions: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  iconButton: {
    width: "42px",
    height: "42px",
    padding: 0,
  },
  button: {
    height: "42px",
    minHeight: "42px",
    borderRadius: "4px",
    opacity: 1,
    boxSizing: "border-box",
    display: "inline-flex",
    alignItems: "center",
    textTransform: "none",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "21px",
    gap: "6px",
    boxShadow: "none",
    backgroundColor: theme.palette.primary.main,
    padding: "10px 16px !important",
    fontFamily: theme.typography.fontFamily,
    "& .MuiButton-startIcon": {
      margin: "0 !important",
    },
  },
  statusFilter: {
    minWidth: "auto",
    
  },
  select: {
    height: "32px",
    minHeight: "32px",
    borderRadius: "9999px",
    opacity: 1,
    background: "transparent",
    backgroundColor: "transparent !important",
    color: theme.palette.primary.main,
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main,
      borderWidth: "1px",
    },
    "&:hover": {
      backgroundColor: "transparent !important",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main,
    },
    "&.Mui-focused": {
      backgroundColor: "transparent !important",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main,
      borderWidth: "1px",
    },
    "& .MuiSelect-select": {
      display: "flex",
      alignItems: "center",
      height: "32px !important",
      minHeight: "32px !important",
      boxSizing: "border-box",
      padding: "6px 12px !important",
      backgroundColor: "transparent !important",
    },
  },
  selectValue: {

    display: "flex",
    flexDirection: "row-reverse",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
    width: "100%",
    height: "32px",
    opacity: 1,
    direction: "ltr",
    color: theme.palette.primary.main,
  },
  statusChartIcon: {
    width: "20px",
    height: "20px",
    flexShrink: 0,
  },
  selectText: {
    flex: 1,
    fontFamily: headerFontFamily,
    fontWeight: 500,
    fontStyle: "normal",
    fontSize: "14px",
    lineHeight: "140%",
    letterSpacing: 0,
    whiteSpace: "nowrap",
    textAlign: "right",
  },
  selectChevron: {
    fontSize: "20px !important",
    color: theme.palette.primary.main,
    flexShrink: 0,
  },
  menuItem: {
    justifyContent: "flex-end",
  },
}));
